import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import LoadingSpinner from "../common/LoadingSpinner";
import ReLoginDialog from "./ReLoginDialog";

const TwoFactorForm = React.lazy(() => import("./TwoFactorForm"));

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated, initialized, requiresTwoFactor, sessionExpired } =
    useAppSelector((state) => state.auth);

  // Spinner only for the first auth check. Later loading states (login,
  // profile update, refresh) must not unmount the page: forms keep their
  // input.
  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  if (requiresTwoFactor && !sessionExpired) {
    return <TwoFactorForm />;
  }

  if (!isAuthenticated && !sessionExpired) {
    // Store the current path so we can redirect back after login
    const currentPath = window.location.pathname;
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(currentPath)}`}
        replace
      />
    );
  }

  // Session lost: the re-login dialog lies over the still mounted page.
  return (
    <>
      {children}
      {sessionExpired && <ReLoginDialog />}
    </>
  );
};

export default ProtectedRoute;
